

import { useContext } from "react";
import { TeamContext, UserContext } from "../context";
import { ICard } from "../interfaces";
import { CardType } from "../util/enums";

const useCard = () => {
    const { game } = useContext(TeamContext);
    const { emailOfSelectedPlayerBoard } = useContext(UserContext);

    const card = (type: CardType) => {
        let notMappedCard: any = game?.gameInfo.players[emailOfSelectedPlayerBoard || ""]?.currentSolutionCards[type];
        //TAGUJEM
        if (notMappedCard)
            return {
                backImagePath: "https://opengameart.org/sites/default/files/card%20back%20red.png",
                content: notMappedCard.description,
                id: notMappedCard._id,
                title: notMappedCard.title,
                type: notMappedCard.type,
                info: notMappedCard.info,
                language: notMappedCard.language
            }
    };

    return [card]
}

export default useCard;